/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {declineShiftCover} from '../api'

export const useMutationDeclineShiftCover = createReactQueryMutationHook('declineShiftCover', declineShiftCover)
